export const STUDIO_NAVIGATION_GROUPS = [
    "Database",
    "Compute",
    "API",
    "Storage",
    "Access Control"
];
